import React from "react";

import DateRangeBar from "ui/DateRangeBar";
import ExpandableSQL from "ui/ExpandableSQL";
import PageContent from "ui/PageContent";
import Panel from "ui/Panel";
import PanelSection from "ui/PanelSection";

import QueryDetailsStats from "../QueryDetailsStats";
import QueryDetailsTitle from "../QueryDetailsTitle";
import type { FingerprintQueryDetailsFragment } from "./gql/Fragment.generated";

function FingerprintQueryDetails({
  fingerprint,
  stats,
}: {
  fingerprint: string;
  stats?: FingerprintQueryDetailsFragment | null;
}) {
  return (
    <PageContent
      windowTitle={`Query ${fingerprint}`}
      title={stats ? undefined : `Query ${fingerprint}`}
      pageControls={<DateRangeBar />}
      featureInfo={
        stats ? (
          <div className="md:flex md:justify-between">
            <QueryDetailsTitle
              fingerprint={stats.fingerprint}
              truncatedQuery={stats.truncatedQuery}
            />
            <QueryDetailsStats
              avgTime={stats.avgTime}
              callsPerMinute={stats.callsPerMinute}
            />
          </div>
        ) : null
      }
      pageCategory="queries"
      pageName="show"
    >
      <Panel title="SQL Statement">
        <PanelSection>
          {stats ? (
            <ExpandableSQL sql={stats.normalizedQuery} />
          ) : (
            "No query statistics available."
          )}
        </PanelSection>
      </Panel>
    </PageContent>
  );
}

export default FingerprintQueryDetails;
